import React from "react";
import { FormattedMessage } from "react-intl";

import { cn } from "~/common/redesign-v1/cn";
import { Download, Plus } from "~/common/redesign-v1/icons";
import { Button } from "~/common/redesign-v1/ui/button";

export function FileDropzone({
  onChoose,
  disabled = false,
  dragging = false,
  testId,
  className,
  children,
}: {
  onChoose?(): void;
  disabled?: boolean;
  dragging?: boolean;
  testId?: string;
  className?: string;
  children?: React.ReactNode;
}) {
  return (
    <div
      className={cn(
        "rd-dashed-upload rd-file-dropzone tw-flex tw-flex-col tw-gap-2 tw-bg-transparent tw-p-0 tw-transition-colors",
        "desktop:tw-flex-row desktop:tw-flex-wrap desktop:tw-items-center desktop:tw-gap-3 desktop:tw-bg-muted desktop:tw-p-6",
        dragging && "rd-dashed-upload-active desktop:tw-bg-accent",
        disabled ? "tw-cursor-not-allowed tw-opacity-50" : "tw-cursor-pointer hover:tw-bg-muted desktop:hover:tw-bg-accent",
        className,
      )}
    >
      <span className="tw-hidden tw-size-14 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-lg tw-bg-background tw-text-foreground desktop:tw-flex" aria-hidden>
        <Download className="tw-size-6" strokeWidth={1.5} />
      </span>

      <div className="tw-flex tw-flex-col tw-gap-1 desktop:tw-min-w-[200px] desktop:tw-flex-1">
        <span className="tw-text-sm tw-font-semibold tw-leading-5 tw-text-foreground">
          <FormattedMessage id="BTN_ADD_FILES" />
        </span>
        <span className="tw-max-w-[452px] tw-text-xs tw-leading-4 tw-text-muted-foreground">
          <span className="desktop:tw-hidden">
            <FormattedMessage id="patient.files.dropzone.hint_mobile" />
          </span>
          <span className="tw-hidden desktop:tw-inline">
            <FormattedMessage id="patient.files.dropzone.hint" />
          </span>
        </span>
      </div>

      <Button type="button" className="tw-w-full desktop:tw-ml-auto desktop:tw-w-auto" data-testid={testId} disabled={disabled} onClick={onChoose}>
        <Plus className="tw-mr-2 tw-size-4 tw-shrink-0" aria-hidden />
        <FormattedMessage id="patient.files.dropzone.choose" />
      </Button>

      {children}
    </div>
  );
}
